import React from "react";

// エラーメッセージのバー（×で閉じる）。マイページ各画面で共通利用。
// 表示制御は呼び出し側（{error && <ErrorBar .../>}）。message=本文, onClose=×押下時。
export default function ErrorBar({ message, onClose }) {
  return (
    <div className="mp-msg mp-err">
      {message}
      <button className="mp-x" onClick={onClose}>×</button>
    </div>
  );
}
